import React, { useState, useMemo } from "react";
import { filmStore } from "@/store/film";
import { storeUser } from "@/store/user";
import { observer } from "mobx-react-lite";

import ModalVoiceover from "@/components/voiceover/ModalVoiceover";
import VoiceoverCard from "@/components/voiceover/VoiceoverCard";
import VoiceoverReorder from "@/components/voiceover/VoiceoverReorder";

import "./styles/film-video-files.scss";

interface Props {
  updateRemoveList: (item:any) => void;
  movieId?: number | string;
  onVoiceoversChanged?: () => void;
}

const FilmVideoFiles = observer(({updateRemoveList, movieId, onVoiceoversChanged}:Props) => {
  const [isShowModal, setIsShowModal] = useState(false);
  const [activeVoiceover, setActiveVoiceover] = useState(null);
  const [action, setAction] = useState(null);
  const [isReorderVisible, setIsReorderVisible] = useState(false);

  const onRemoveFile = (index: number, item:any) => {
    filmStore.removeVoiceOvers(index);
    
    updateRemoveList(item)
  };

  const onAddFile = () => {
    setIsShowModal(true);
  };

  const handleVoiceoverClose = () => {
    setIsShowModal(false);
    setActiveVoiceover(null);
  };

  const onEditFile = (index: number, data) => {
    setActiveVoiceover(data);
    setAction('edit')

    setTimeout(() => {
      setIsShowModal(true);
    }, 900);
  };

  const voiceovers = useMemo(() => {
    return filmStore.listVoiceovers;
  }, [filmStore.listVoiceovers])

  return (
    <div className={"film-video-files"}>
      <div className="film-video-files__header app-section-header">
        <h6 className={"film-video-files__title app-section-header__title"}>Видео файлы</h6>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          {movieId && voiceovers.length > 1 && storeUser.isSuperAdmin && (
            <button className="app-btn secondary" onClick={() => setIsReorderVisible(true)}>
              Порядок
            </button>
          )}
          <button className={"app-btn"} onClick={onAddFile}>
            Добавить озвучку
          </button>
        </div>
      </div>

      <div className={"film-video-files__content"}>
        <div className={"film-video-files__list"}>
          {voiceovers.map((voiceover, index) => {
            return <VoiceoverCard
                remove={onRemoveFile}
                edit={onEditFile}
                index={index}
                isEdit={true}
                data={voiceover}
                key={voiceover.id}
              />
          })}
        </div>
      </div>

      {isShowModal && (
        <ModalVoiceover
          close={handleVoiceoverClose}
          voiceover={activeVoiceover}
          save={handleVoiceoverClose}
        />
      )}

      {movieId && (
        <VoiceoverReorder
          voiceovers={voiceovers.map((v: any) => ({
            video_id: v.video_id,
            name: v.name || v.voiceoverName || '',
            sort_order: v.sort_order ?? null,
          }))}
          visible={isReorderVisible}
          movieId={movieId}
          onClose={() => setIsReorderVisible(false)}
          onSaved={() => onVoiceoversChanged?.()}
        />
      )}
    </div>
  );
});

export default FilmVideoFiles;
